var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"fill-height",attrs:{"id":"app"}},[_c('v-main',[(_vm.isFetched)?[_c('router-view')]:_c('main-loader'),_c('the-snackbar')],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }